import { useEffect, useState } from 'react';
import { statsigClient } from '../utils/analytics';

export function useLandingEmailCapture() {
  const [captureEmail, setCaptureEmail] = useState(true); // default to true for safety

  useEffect(() => {
    if (!statsigClient) return;
    const config = statsigClient.getDynamicConfig('landing_email_capture');
    setCaptureEmail(config.get('capture_email', true));
  }, []);

  return captureEmail;
}
